export default __webpack_public_path__ + "static/media/badge.a6bdaceb.jpg";